<div class="row">
  <div class="col fw-600 fs-14p">
    {{ 'workspaces.detailedVarianceAnalysis' | transloco }}
  </div>
</div>
<div class="row">
  <div class="col">
    {{
      'workspaces.detailedVarianceAnalysisText'
        | transloco: { referenceDocumentName: selectedReferenceDocument?.name }
    }}
  </div>
</div>

<div class="row mt-10p">
  <div class="col">
    <div [formGroup]="form" class="row-adaptive filters detailed-alignment__filters">
      <div class="col-adaptive main-filter-col">
        <app-search-input
          placeholder="{{ 'workspaces.filterByClauseName' | transloco }}"
          formControlName="clauseName"
          class="filter-control"
        ></app-search-input>
      </div>

      <div class="col-adaptive">
        <app-single-select-autocomplete
          formControlName="targetDocumentId"
          [autocompleteOptions]="targetDocumentOptions"
          [placeholderKey]="'workspaces.targetDocument'"
        ></app-single-select-autocomplete>
      </div>

      <div class="col-adaptive">
        <app-single-select-autocomplete
          formControlName="legalEquivalence"
          [autocompleteOptions]="legalEquivalenceOptions"
          [placeholderKey]="'workspaces.legalEquivalence'"
          [refreshCollectionByTranslationEvent]="true"
        ></app-single-select-autocomplete>
      </div>

      <div class="col-adaptive filter-btn-col">
        <app-button
          icon="close"
          [type]="btnTypes.Icon_Stroked"
          [size]="btnSizes.InFilterRow"
          [label]="'buttons.clearFilters' | transloco"
          (onClick)="clearFilters()"
        ></app-button>
      </div>
    </div>

    <div class="analyzing-dashboard__occurrence-table mt-2 mb-2">
      <div class="analyzing-dashboard__documents analyzing-dashboard__documents--detailed">
        <div class="analyzing-dashboard__header analyzing-dashboard__header--detailed">
          <div>{{ 'workspaces.clause' | transloco }}</div>
          <div>{{ 'workspaces.targetDocument' | transloco }}</div>
          <div>{{ 'workspaces.targetClause' | transloco }}</div>
          <div>{{ 'workspaces.legalEquivalence' | transloco }}</div>
          <div>{{ 'workspaces.legalDifferences' | transloco }}</div>
          <div>{{ 'workspaces.legalConsequences' | transloco }}</div>
        </div>

        @if (filteredDetailedRows.length) {
          @for (row of filteredDetailedRows; track row.id) {
            <div class="analyzing-dashboard__row analyzing-dashboard__row--detailed">
              <div
                class="analyzing-dashboard__cell"
                [attr.data-label]="'workspaces.clause' | transloco"
              >
                {{ row.clauseName }}
              </div>
              <div
                class="analyzing-dashboard__cell"
                [attr.data-label]="'workspaces.targetDocument' | transloco"
              >
                {{ row.targetDocumentName }}
              </div>
              <div
                class="analyzing-dashboard__cell"
                [attr.data-label]="'workspaces.targetClause' | transloco"
              >
                {{ row.targetClause }}
              </div>
              <div
                class="analyzing-dashboard__cell"
                [attr.data-label]="'workspaces.legalEquivalence' | transloco"
              >
                <div
                  class="detailed-alignment__equivalence"
                  [class.detailed-alignment__equivalence--yes]="
                    row.legalEquivalence === DetailedClauseAlignmentStatus.Yes
                  "
                  [class.detailed-alignment__equivalence--no]="
                    row.legalEquivalence === DetailedClauseAlignmentStatus.No
                  "
                >
                  @if (row.legalEquivalence === DetailedClauseAlignmentStatus.Yes) {
                    <span>{{ 'buttons.yes' | transloco }}</span>
                  } @else {
                    <span>{{ 'buttons.no' | transloco }}</span>
                  }
                </div>
              </div>
              <div
                class="analyzing-dashboard__cell"
                [attr.data-label]="'workspaces.legalDifferences' | transloco"
              >
                {{ row.legalDifferences }}
              </div>
              <div
                class="analyzing-dashboard__cell"
                [attr.data-label]="'workspaces.legalConsequences' | transloco"
              >
                {{ row.legalConsequences }}
              </div>
            </div>
          }
        } @else {
          <div class="analyzing-dashboard__empty">
            {{
              loadingReviewDataComplete
                ? ('workspaces.noDetailedClauseAlignmentRows' | transloco)
                : ('workspaces.loadingDetailedClauseAlignment' | transloco)
            }}
          </div>
        }
      </div>
    </div>
  </div>
</div>
